import type { LoaderProps } from "../../components";
import type { ILoader } from "../../components/Loader/types";
import type { PickOfUnion } from "../../types/react";

type LoaderCustomProps = PickOfUnion<
    LoaderProps,
    "view" | "customColorsStyles"
> &
    Pick<ILoader, "size">;

type GetLoaderPropsArgs = {
    view?: string;
    size?: string;
    customColorsStyles?: string;
};

export const getLoaderProps = ({
    view,
    size,
    customColorsStyles,
}: GetLoaderPropsArgs) => {
    return {
        view,
        size,
        ...(view === "custom"
            ? {
                  customColorsStyles,
              }
            : {}),
    } as LoaderCustomProps;
};
